export default "__VITE_ASSET__80288512__"